import "core-js/modules/es6.regexp.to-string";
import _classCallCheck from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
var TOAST_STYLE = "\n  display: block;\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 100%;\n  z-index: 99999999;\n";
var CONTAINER_STYLE = "\n  width: 100%;\n  height: 100%;\n  border-radius: 7px;\n  color: #fff;\n  position: absolute;\n  -webkit-display: flex;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n";
var LOADING_STYLE = "\nbackground: rgba(34,34,34,.85);\nmin-width: 90px;\nheight: 90px;\ndisplay: flex;\npadding: 10px;\nflex-direction: column;\nborder-radius: 10px;\njustify-content: center;\nalign-items: center;\nfont-size: 14px;\nfont-weight: normal;\nmargin-top: -50px;\n";
var LOADING_GIF = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" style=\"margin: auto; display: block; shape-rendering: auto;\" width=\"35px\" height=\"35px\" viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid\">\n<g transform=\"rotate(0 50 50)\">\n  <rect x=\"45\" y=\"2.5\" rx=\"5\" ry=\"6.2\" width=\"10\" height=\"31\" fill=\"#ffffff\">\n    <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"-0.875s\" repeatCount=\"indefinite\"></animate>\n  </rect>\n</g><g transform=\"rotate(45 50 50)\">\n  <rect x=\"45\" y=\"2.5\" rx=\"5\" ry=\"6.2\" width=\"10\" height=\"31\" fill=\"#ffffff\">\n    <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"-0.75s\" repeatCount=\"indefinite\"></animate>\n  </rect>\n</g><g transform=\"rotate(90 50 50)\">\n  <rect x=\"45\" y=\"2.5\" rx=\"5\" ry=\"6.2\" width=\"10\" height=\"31\" fill=\"#ffffff\">\n    <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"-0.625s\" repeatCount=\"indefinite\"></animate>\n  </rect>\n</g><g transform=\"rotate(135 50 50)\">\n  <rect x=\"45\" y=\"2.5\" rx=\"5\" ry=\"6.2\" width=\"10\" height=\"31\" fill=\"#ffffff\">\n    <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"-0.5s\" repeatCount=\"indefinite\"></animate>\n  </rect>\n</g><g transform=\"rotate(180 50 50)\">\n  <rect x=\"45\" y=\"2.5\" rx=\"5\" ry=\"6.2\" width=\"10\" height=\"31\" fill=\"#ffffff\">\n    <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"-0.375s\" repeatCount=\"indefinite\"></animate>\n  </rect>\n</g><g transform=\"rotate(225 50 50)\">\n  <rect x=\"45\" y=\"2.5\" rx=\"5\" ry=\"6.2\" width=\"10\" height=\"31\" fill=\"#ffffff\">\n    <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"-0.25s\" repeatCount=\"indefinite\"></animate>\n  </rect>\n</g><g transform=\"rotate(270 50 50)\">\n  <rect x=\"45\" y=\"2.5\" rx=\"5\" ry=\"6.2\" width=\"10\" height=\"31\" fill=\"#ffffff\">\n    <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"-0.125s\" repeatCount=\"indefinite\"></animate>\n  </rect>\n</g><g transform=\"rotate(315 50 50)\">\n  <rect x=\"45\" y=\"2.5\" rx=\"5\" ry=\"6.2\" width=\"10\" height=\"31\" fill=\"#ffffff\">\n    <animate attributeName=\"opacity\" values=\"1;0\" keyTimes=\"0;1\" dur=\"1s\" begin=\"0s\" repeatCount=\"indefinite\"></animate>\n  </rect>\n</g>\n</svg>\n"; // Loading 较大样式

var LOADING_SIZE_BIG = 'big';
var LOADING_BIG_SIZE = '110px';
export function hideLoading() {
  var $el = document.querySelectorAll('.__atom_toast__');

  if ($el && $el.length) {
    for (var i = 0, len = $el.length; i < len; i++) {
      if ($el[i] && $el[i].parentElement) {
        $el[i].parentElement.removeChild($el[i]);
      }
    }
  }
}

var Loading = /*#__PURE__*/function () {
  function Loading() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      size: 'small'
    };

    _classCallCheck(this, Loading);

    if (typeof text !== 'string') {
      this.text = '';
      this.options = text;
    } else {
      this.text = text;
      this.options = options;
    }

    this.createToastDom();
  }

  _createClass(Loading, [{
    key: "show",
    value: function show() {
      this.$toast.style.display = 'block';
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.$toast && this.$toast.parentElement) {
        this.$toast.style.display = 'none';
        this.$toast.parentElement.removeChild(this.$toast);
      }
    }
  }, {
    key: "createToastDom",
    value: function createToastDom() {
      var _this = this;

      var $toast = document.createElement('div');
      var $contain = document.createElement('div');
      var $loading = document.createElement('i');
      var loadingSize = this.options.size;
      $loading.innerHTML = LOADING_GIF;
      $toast.id = Math.random().toString(36).substr(2);
      $toast.className = '__atom_toast__';
      $toast.setAttribute('style', TOAST_STYLE);

      $toast.ontouchmove = function (e) {
        e.preventDefault();
      };

      $loading.setAttribute('style', LOADING_STYLE);
      $contain.appendChild($loading);
      $contain.setAttribute('style', CONTAINER_STYLE);
      $toast.appendChild($contain);

      if (this.text !== '') {
        var $text = document.createElement('span');
        $text.innerText = this.text;
        $text.setAttribute('style', 'margin:0;color:#fff;line-height: 1.5;top:-5px;position:relative;');
        $loading.appendChild($text);
        loadingSize = LOADING_SIZE_BIG;
      }

      if (loadingSize === LOADING_SIZE_BIG) {
        $loading.style.height = LOADING_BIG_SIZE;
        $loading.style.minWidth = LOADING_BIG_SIZE;
      } // 允许手动触发关闭事件


      if (this.options.close) {
        $toast.onclick = function () {
          _this.hide();
        };
      }

      if (this.options.timeout) {
        setTimeout(this.hide.bind(this), this.options.timeout);
      }

      document.body.appendChild($toast);
      this.$toast = $toast;
    }
  }]);

  return Loading;
}();

export { Loading as default };